import React, { useCallback, useEffect, useRef, useState } from "react";
import { z, ZodType } from "zod";
// External dependencies
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Logos and assets
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";


// Internal Dependencies
import { v2ReactURL } from "../../utils/constant.ts";
import { ContactContainer } from "./ContactContainer.tsx";
// Import necessary libraries and components from PageImports.js
import { Helmet } from "react-helmet";
import CustomButton from "../../components/common/CustomButton/CustomButton.tsx";
import { contactTabs, CustomColumnMenuComponent, CustomTabPanel, Expanded, ImportExport, SelectedRowsButtons, SubHeaderTitle, Tabination } from "../../components/common/index";
import { ActiveDeactiveCustomerFunc } from "../../components/commonFunctions/ActiveDeactiveCustomerFunc.ts";
import useBranchListApi from "../../hooks/useBranchListApi.ts";
import useContactRelatedApi, { ExtendedMemberType } from "../../hooks/useContactRelatedApi.ts";
import {
  resetAnalyticsData,
} from "../../store/index.ts";
import Loader from "../../utils/Loader.tsx";
import ErrorPage from "../Error/ErrorPage.tsx";
import { CommonData, CommonFunctions } from "../PageImports.ts";
const {
  Wrapper,
  WrapperSubHeader,
  WrapperContent,
  WrapperCard,
  Row,
  CustomDataTable,

} = CommonData;
// import {
//   getCommonIds,
//   splitJoinedStrings,
// } from "../../utils/FilterRelatedFunc.ts";
import { CircularProgress } from "@mui/material";
import { Column } from "../../components/common/CustomDataTable/CustomDataTable.tsx";
import { CustomerColumns } from "../../components/common/DataTableColumns/CustomerColumns.tsx";
import { SupplierColumns } from "../../components/common/DataTableColumns/SupplierColumns.tsx";
import { TransporterColumns } from "../../components/common/DataTableColumns/TransporterColumns.tsx";
import CircularProgressCountUp from "../../components/common/spinner/CircularProgressCountUp.tsx";
import { SwalFunction } from "../../components/commonFunctions/SwalFunction.ts";
import EditPointsDialog from "../../components/VLoyalty/EditPointsDialog.tsx";
import { setContactPayloadData } from "../../store/Contact/contactPayloadSlice.ts";
import { setContactType } from "../../store/Contact/contactTypeSlice.ts";
import { useDynamicMenuAction } from "../../store/ContextApi/DynamicMenuActionContext.tsx";
import { apiResponseHandler } from "../../utils/functions/apiResponseHandler.ts";
import { handleApplyFilter } from "../../utils/functions/handleApplyFilter.tsx";
import { getActiveStatus, getCityIds, getContactTypes, getCountryIds, getCreatedByIds, getIsMobNoVerify, getLocationIds, getMembershipIds, getPinCodes, getStateIds } from "../../utils/functions/handleSearchUtility.tsx";

// import { toast } from "react-toastify";
// import {
//   getLocationIds,
//   getMembershipIds,
//   getIsMobNoVerify,
//   getCityIds,
//   getPinCodes,
//   getCreatedByIds,
//   getActiveStatus,
//   getContactTypes,
// } from "../../utils/functions/handleSe";

const { axiosFunction, DeleteContactFunc, toastMessage, } =
  CommonFunctions;
interface ContactProps {
  navUrl: string;
}
const contactSchema = z.object({
  email: z.string().optional(),
  companyId: z.number(),
  contactId: z.number(),
  totalSales: z.number().optional(),
  firstName: z.string().nullable(),
  addressLine1: z.string().nullable(),
  addressLine2: z.string().nullable(),
  companyName: z.string().nullable(),
  lastName: z.string(),
  pinCode: z.string().nullable(),
  dateOfBirth: z.string().nullable().optional(),
  branchId: z.number(),
  cityName: z.string(),
  stateName: z.string().nullable().optional(),
  countryName: z.string().nullable().optional(),
  telephone: z.string(),
  membershipName: z.string(),
  isDefault: z.number().optional().nullable(),
  customerCategoryName: z.string().optional().nullable(),
  countryDialCodePrefix: z.number(),
  mobNo: z.string(),
  whatsAppNo: z.string(),
  anniversaryDate: z.string().nullable(),
  contactType: z.string(),
  isMobNoVerify: z.number(),
  bankIfsc: z.string(),
  countryDialCodePrefixWhatsapp: z.number(),
  gstType: z.string(),
  vatNo: z.string(),
  gstin: z.string(),
  panNo: z.string().nullable(),
  bankName: z.string(),
  bankBranch: z.string(),
  openingType: z.string(),
  createdByName: z.string(),
  isBranch: z.number(),
  bankAccNo: z.string(),
  openingAmount: z.string(),
  avgBillValue: z.number(),
  name: z.string(),
  location: z.string(),
  active: z.number(),
  loyaltyPoints: z.number(),
});
export type RowData = z.infer<typeof contactSchema>;
export type Pagination = z.infer<typeof dataTableMetaDTOSchema>;

export const dataTableMetaDTOSchema = z.object({
  page: z.number(),
  pages: z.number(),
  perpage: z.number(),
  total: z.number(),
});

export const responseSchema = z.object({
  recordsFiltered: z.number(),
  recordsTotal: z.number(),
  draw: z.number(),
  error: z.nullable(z.string()),
  dataTableMetaDTO: dataTableMetaDTOSchema,
  data: z.array(contactSchema),
});


export function createResponseSchema<T extends ZodType<any>>(itemSchema: T) {
  return z.object({
    recordsFiltered: z.number(),
    recordsTotal: z.number(),
    draw: z.number(),
    error: z.nullable(z.string()),
    dataTableMetaDTO: dataTableMetaDTOSchema,
    data: z.array(itemSchema),
  });
}

export interface DynamicCol {
  key: string;
  value: boolean;
  columnTitle: string;
}
 export const capitalizeFirstChar = (string: string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

export interface ErrorState {
  code: string;
  message: string;
}
interface LocationValue {
  id: number;
  userFrontId: number;
}
type RecordValue<T> = Record<string | number, T>;
interface GenericValue<T> {
  value: T;
}
export interface CheckedValue {
  location?: RecordValue<LocationValue>;
  membershipName?: RecordValue<{ id: number }>;
  isMobNoVerify?: RecordValue<GenericValue<string>>;
  cityName?: RecordValue<{ city_id: number }>;
  stateName?: RecordValue<{ state_id: number }>;
  countryName?: RecordValue<{ country_id: number }>;
  gstType?: RecordValue<GenericValue<string>>;
  customerSegment?: RecordValue<GenericValue<string>>;
  pinCode?: RecordValue<{ pin_code: string }>;
  createdByName?: RecordValue<{ userid: number }>;
  active?: RecordValue<GenericValue<string>>;
  contactType?: RecordValue<GenericValue<string>>;
  [key: string]: RecordValue<any> | undefined; // Allow additional dynamic keys
}

  type DebouncedFunction<T extends (...args: any[]) => any> = (...args: Parameters<T>) => void;
  export function debounce<T extends (...args: any[]) => any>(func: T, delay: number): DebouncedFunction<T> {
    const timer = useRef<ReturnType<typeof setTimeout>>();
    return (...args: Parameters<T>) => {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => func(...args), delay);
    };
  }

const MainParentComponent: React.FC<ContactProps> = ({ navUrl }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const contactType = useSelector((state: any) => state.contactType);
  const {
    searchMembershipResults,
    membershipList,
    setMembershipList,
    contactRelatedData,
    loadingContactData,
  } = useContactRelatedApi(contactType);
  const sessionList = useSelector((state: any) => state.sessionData.sessionScope) ;
  const sessionBranchId = sessionList?.branchId;
  useState<MenuActions>()
  // const contactPayloadData = useSelector((state:any) => state.contactPayloadData);
  const { dynamicMenuAction, setDynamicMenuAction } = useDynamicMenuAction();
  const [searchInputValue, setSearchInputValue] = useState<string>('');
  const [rows, setRows] = useState<RowData[]>([]); // state for custom data table --> Rows (Real time api data)...
  const [loadingData, setLoadingData] = useState<boolean>(false); // state for custom data table --> Loading (Real time api data)...
  const [pagination, setPagination] = useState<Pagination>({
    page: 0,
    pages: 0,
    perpage: 0,
    total: 0,
  }); // state for custom data table --> pagination...
    // const [selectedCard, setSelectedCard] = useState<SelectedCard>({});
  const [pageOption, setPageOption] = useState<string>('15'); // state for custom data table --> Page Options...
  const [searchValue, setSearchValue] = useState<string>(''); // state for custom data table --> Searching the data..
  const [searchColumn, setSearchColumn] = useState<string>('');
  const [tabView, setTabView] = useState<string>("customers"); // state for managing the tab view--> customers/ suppliers/ Transport ...
  const [dynamicColumn, setDynamicColumn] = useState<Column[]>([]); // state for custom data table --> column for 3 tabs...
  const [checked, setChecked] = useState<boolean>(false); // set as default checkbox state...
  const [openColumnMenu, setOpenColumnMenu] = useState<boolean>(false);
  const [progress, setProgress] = useState(0);
  // const [isLoadingExcel, setIsLoadingExcel] = React.useState(false);
  const [dynamicCol, setDynamicCol] = useState<DynamicCol[]>([]);// Dynamic Columns......
  const [tableData, setTableData] = useState(dynamicColumn);
  interface MenuActions {
    Insert: number;
    Delete: number
    Edit: number;
    View: number
    // [key: string]: any;  
  }
  const [editPointsDialogData, setEditPointsDialogData] = useState<{
    open: boolean;
    mobNo?: string;
    points?: number | null | undefined;
  }>({open: false});

  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [refreshAnalytics , setRefreshAnalytics] = useState<boolean>(false);
  const [openRowMenuId, setOpenRowMenuId] = useState<number | null>(null);
  const menuRef = useRef<HTMLDivElement>(null);

  const viewAnalyticData = useSelector((state: any) => state.analyticsData);

  const [selectedBranch, setSelectedBrach] = useState<number[]>(
    sessionBranchId ? [sessionBranchId] : [] as number[]
  )
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isLoadingExcel, setIsLoadingExcel] = useState<boolean>(false);
  const [openFilter, setOpenFilter] = useState<string | null>(null);
  const { branchLocationList, setBranchLocationList, searchBranchResults } = useBranchListApi();

  const [checkedValue, setCheckedValue] = useState<CheckedValue>({
    location: {
      [sessionBranchId]: {
        id: sessionBranchId,
        userFrontId: sessionBranchId,
      },
    },
  });
  const [contactFilteredIds, setContactFilteredIds] = useState<string[]>([]);
  const [filterData, setFilterData] = useState<any[]>([]);
  const [filteringData, setFilteringData] = useState({});
  useEffect(() => {
    setSelectedBrach(sessionBranchId ? [sessionBranchId] : []);
  }, [sessionBranchId]);
  const [error, setError] = useState<ErrorState | null>(null);
  const fetchData = async (
      searchValue: string,
      startIndex: number,
      pageLength: number,
      branchIds: number[] = selectedBranch,
      membershipIds = selectedMembership,
      isMobNoVerify: string,
      viewAnalyticData: any,
      contactIds: string[] = [],
      cityIds: number[] = [],
      stateIds: number[] = [],
      countryIds: number[] = [],
      pincodes: string[] = [],
      createdByIds: number[] = [],
      status = "",
      contactTypes: string[] = [],
      gstTypeArray: string[] = [],
      customerSegmentType: string = ""
    ): Promise<void> => {
    setLoadingData(true);
    const payloadData = {
      searchValue: searchValue,
      branchIds: branchIds,
      contactIds: contactIds,
      isMobNoVerify: isMobNoVerify,
      membershipIds: membershipIds,
      contactType: contactTypes,
      gstTypeArray:gstTypeArray,
      length: pageLength,
      start: startIndex,
      draw: 1,
      createdByIds: createdByIds,
      cityIds: cityIds,
      stateIds: stateIds,
      countryIds: countryIds,
      pincodes: pincodes,
      status: status,
      customerSegmentType: customerSegmentType,
      ...viewAnalyticData,
    };
    setLoadingData(true);
    dispatch(setContactPayloadData(payloadData));
    handleSelectAllChange({
      target: { checked: false },
      stopPropagation: () => {},
    } as React.ChangeEvent<HTMLInputElement>);
    
    //  console.log("contactRelatedData",contactRelatedData.permissions)
  
    try {
      const res = await axiosFunction(
        `${v2ReactURL}/contact/${tabView}/customdatatable`,
        "POST",
        payloadData
      );
      const validatedData = responseSchema.safeParse(res.data);
      if (validatedData.success) {
        const contactList = validatedData.data?.data?.map((col: any, index: number) => ({
          ...col,
          index: index + 1,
          checked: false,
        }));
        if (res?.status == 200) {
          setLoadingData(false);
          setPagination(validatedData.data?.dataTableMetaDTO);
          setRows(contactList);
          // setRefreshAnalytics(!refreshAnalytics);
        }
      } else {
        console.error("API response validation failed:", validatedData.error);
      }
      if (
        res?.code == "ERR_NETWORK" ||
        res?.message == "network error"
      ) {
        setIsLoading(true);
        setError({
          code: res?.code || "502",
          message:
            res.message ||
            "// Hang tight! Our checkout lanes are undergoing maintenance. We'll be back to serving you real soon! ",
        });
      } else if (res?.response?.status == 400) {
        setIsLoading(true);
        setError({
          code: res?.response?.status || "400",
          message:
            res?.message ||
            "Oops, your request got lost in translation! Maybe try again with simpler instructions? ",
        });
      } else if (res?.response?.status == 404) {
        setIsLoading(true);
        setError({
          code: res?.response?.status || "404",
          message:
            res?.message ||
            "Oopsie! Looks like this page went on vacation. Maybe try a different path?",
        });
      } else if (res?.response?.status == 500) {
        setIsLoading(true);
        setError({
          code: res?.response?.status || "500",
          message:
            res?.message ||
            "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
        });
      }
      setIsLoading(true);
    } catch (error: any) {
      if (error.code == "ERR_NETWORK") {
        setError({
          code: "500",
          message:
            "Uh-oh, our server's taking a coffee break. It'll be back to ringing up sales soon!",
        });
      }
      toastMessage("Error fetching contact details");
      setLoadingData(false);
    }

  };
  const [selectedMembership, setSelectedMembership] = useState<number[]>([]);
  const [open, setOpen] = useState(contactTabs.map(() => true));
  const [selectedStatus, setSelectedStatus] = useState({
    value: "all",
    label: "All",
  });

  const [isShowCreateBtn, setIsShowCreateBtn] = useState<boolean>(true);

  useEffect(() => {
    setIsShowCreateBtn(Boolean(dynamicMenuAction?.Insert));
  }, [tabView, dynamicMenuAction]);

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>, itemType: string) => {
    const value = e.target.value.trimStart();
    if (itemType === "branch") {
      // setSearchBranch(value);
      if (value === "") {
        setBranchLocationList(searchBranchResults);
      } else {
        const lowercasedSearchValue = value.toLowerCase();
        const filteredList = searchBranchResults.filter((branch: { id: number; name: string; userFrontId: number }) =>
          branch.name.toLowerCase().includes(lowercasedSearchValue)
        );
        setBranchLocationList(filteredList);
      }
    } else {
      // setSearchMembership(value);
      if (value === "") {
        setMembershipList(searchMembershipResults);
      } else {
        const lowercasedSearchValue = value.toLowerCase();
        const filteredList = searchMembershipResults.filter((mem: ExtendedMemberType) =>
          mem.name.toLowerCase().includes(lowercasedSearchValue)
        );
        setMembershipList(filteredList);
      }
    }
  };
  const handleRowMenuOpen = (event: React.MouseEvent<HTMLElement>, rowId: number) => {
    event.stopPropagation();
    setOpenRowMenuId(openRowMenuId == rowId ? null : rowId);
  };
  useEffect(() => {
    const handleOutsideClick = (_event: MouseEvent) => {
        setOpenRowMenuId(null);
    };

    if (openRowMenuId !== null) {
      document.addEventListener("click", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [openRowMenuId]);

  const handleDeleteCustomer = (contactId: number) => {
    DeleteContactFunc([contactId], navigate, contactType, refreshAnalytics, setRefreshAnalytics, false, () => fetchData(searchValue, pagination.page * parseInt(pageOption), parseInt(pageOption), selectedBranch, selectedMembership, selectedStatus.value, viewAnalyticData, contactFilteredIds,
      checkedValue["cityName"] ? Object.keys(checkedValue["cityName"]).map((key) => checkedValue["cityName"]?.[key]?.city_id).filter((id): id is number => id !== undefined) : [],
      checkedValue["stateName"] ? Object.keys(checkedValue["stateName"]).map((key) => checkedValue["stateName"]?.[key]?.state_id).filter((id): id is number => id !== undefined) : [],
      checkedValue["countryName"] ? Object.keys(checkedValue["countryName"]).map((key) => checkedValue["countryName"]?.[key]?.country_id).filter((id): id is number => id !== undefined) : [],
      checkedValue["pinCode"] ? Object.keys(checkedValue["pinCode"]).map((key) => checkedValue["pinCode"]?.[key]?.pin_code).filter((pinCode): pinCode is string => pinCode !== undefined) : [],
      checkedValue["createdByName"] ? Object.keys(checkedValue["createdByName"]).map((key) => checkedValue["createdByName"]?.[key]?.userid).filter((id): id is number => id !== undefined) : [], 
      checkedValue["active"] ? Object.keys(checkedValue["active"]).map((key) => checkedValue["active"]?.[key]?.value).join(", ") : "",
       checkedValue["contactType"] ? Object.keys(checkedValue["contactType"]).map((key) => checkedValue["contactType"]?.[key]?.value).filter((value): value is string => value !== undefined) : []));
  };

  const handleEditCustomer = (contactId: number) => {
    localStorage.removeItem("pinCodes");
    navigate(`/reactcontact/${contactId}/edit`);
  };

  const handleActiveDeactiveCustomer = async (row: RowData) => {
    ActiveDeactiveCustomerFunc(row, contactType,() => fetchData(searchValue, pagination.page * parseInt(pageOption), parseInt(pageOption), selectedBranch, selectedMembership, selectedStatus.value, viewAnalyticData, contactFilteredIds, 
    checkedValue["cityName"] ? Object.keys(checkedValue["cityName"]).map((key) => checkedValue["cityName"]?.[key]?.city_id).filter((id): id is number => id !== undefined) : [],
    checkedValue["stateName"] ? Object.keys(checkedValue["stateName"]).map((key) => checkedValue["stateName"]?.[key]?.state_id).filter((id): id is number => id !== undefined) : [],
      checkedValue["countryName"] ? Object.keys(checkedValue["countryName"]).map((key) => checkedValue["countryName"]?.[key]?.country_id).filter((id): id is number => id !== undefined) : [],
    checkedValue["pinCode"] ? Object.keys(checkedValue["pinCode"]).map((key) => checkedValue["pinCode"]?.[key]?.pin_code).filter((pinCode): pinCode is string => pinCode !== undefined) : [],
      checkedValue["createdByName"] ? Object.keys(checkedValue["createdByName"]).map((key) => checkedValue["createdByName"]?.[key]?.userid).filter((id): id is number => id !== undefined) : [],
       checkedValue["active"] ? Object.keys(checkedValue["active"]).map((key) => checkedValue["active"]?.[key]?.value).join(", ") : "",
        checkedValue["contactType"] ? Object.keys(checkedValue["contactType"]).map((key) => checkedValue["contactType"]?.[key]?.value).filter((value): value is string => value !== undefined) : []));
  };
  const handleOpenEditPointDialog = (mobNo: string, points: number | null | undefined) => {
    if (mobNo) {
      setEditPointsDialogData({open: true, mobNo, points});
    } else {
      toastMessage("Customer's Mobile Number Is Not Provided");
    }
  };

  const handleResetPoint = async (mobNo: string, points: number | null | undefined) => {
    if (!points) {
      toastMessage("Current points are zero");
    } else if (!mobNo) {
      toastMessage("Customer's Mobile Number Is Not Provided");
    } else {
      resetPointsApi(false, [mobNo]);
    }
  };
    const resetPointsApi = async (resetAll: boolean, mobNo: string[] | []) => {
      const response = await axiosFunction(`${v2ReactURL}/contact/reset/points`, "POST", {
        resetAll: resetAll,
        mobileNos: mobNo,
      });
  
      const error: ErrorState | null = apiResponseHandler(response, true);
      if (error != null) {
        toastMessage(error.message);
        return;
      }
  
      if (response.data.status) {
        toastMessage("Points has been adjusted successfully!", "success");
        fetchData(searchValue, pagination.page * parseInt(pageOption), parseInt(pageOption), [sessionBranchId], [], selectedStatus.value, viewAnalyticData)
        setSelectedRows([]);
      }
    }
  useEffect(() => {
    const fetchContactRelatedList = async (tabView: string) => {
      const res = await axiosFunction(
        `${v2ReactURL}/contact/listing?type=${tabView}`,
        "GET"
      );

      setDynamicMenuAction(res.data);

    };

    fetchContactRelatedList(tabView);
  }, [tabView]);

  const tabWiseColumns =
    tabView === "customers"
      ? CustomerColumns({
        handleEditCustomer,
        pagination,
        handleRowMenuOpen,
        openRowMenuId,
        menuRef,
        handleDeleteCustomer,
        handleActiveDeactiveCustomer,
        dynamicMenuAction,
        contactRelatedData,
        tabView,
        contactType,
        sessionBranchId,
        sessionList,
        handleOpenEditPointDialog,
        handleResetPoint
      })
      : tabView === "suppliers"
        ? SupplierColumns({
          handleEditCustomer,
          handleRowMenuOpen,
          openRowMenuId,
          menuRef,
          pagination,
          handleDeleteCustomer,
          handleActiveDeactiveCustomer,
          dynamicMenuAction,
          tabView,
          contactType,
          sessionBranchId,
          sessionList,
          handleOpenEditPointDialog,
          handleResetPoint
        })
        : TransporterColumns({
          handleEditCustomer,
          handleRowMenuOpen,
          menuRef,
          openRowMenuId,
          handleDeleteCustomer,
          handleActiveDeactiveCustomer,
          dynamicMenuAction,
          pagination,
          tabView,
          contactType,
          sessionBranchId,
          sessionList,
          handleOpenEditPointDialog,
          handleResetPoint
        });

  useEffect(() => {
    dispatch(setContactType(tabView));
    setDynamicColumn(tabWiseColumns);
    setSearchColumn("");
  }, [tabView]);

  useEffect(() => {
    setTableData(dynamicColumn);
  }, [dynamicColumn]);

  // useEffect(() => {
  //   if (contactRelatedData?.membership === 1 || contactRelatedData?.allowb2b === 1) {
  //     setDynamicColumn(tabWiseColumns);
  //     setDynamicCol(
  //       tabWiseColumns.map((col) => ({
  //         key: col.field || "",
  //         value: col.defaultChecked || false,
  //         columnTitle: col.headerName || "",
  //       }))
  //     );
  //     setTableData(tabWiseColumns); 
  //     setChecked(true);
  //   }
  // }, [contactRelatedData]);  
  useEffect(() => {
    fetchData(
      searchValue,
      pagination.page * parseInt(pageOption),
      parseInt(pageOption),
      [sessionBranchId],
      [],
      selectedStatus.value,
      viewAnalyticData
    );
  }, [tabView, sessionBranchId]);

  const handleTabChange = (e: React.SyntheticEvent, value: string) => {
    e.preventDefault();
    setTabView(value);
    localStorage.setItem("TabviewValue", value)
    dispatch(resetAnalyticsData());
    setSearchValue("");
    setPagination({
      page: 0,
      pages: 0,
      perpage: 0,
      total: 0,
    });
    setPageOption("15");
    setSelectedRows([]);
    setSelectAll(false);
    setSelectedBrach([sessionBranchId]);
    setSelectedMembership([]);
    setSelectedStatus({
      value: "all",
      label: "All",
    });
    setCheckedValue({
      location: {
        [sessionBranchId]: {
          id: sessionBranchId,
          userFrontId: sessionBranchId,
        },
      },
    });
    setOpenFilter(null);
    setContactFilteredIds([]);
  };
  useEffect(() => {
    setCheckedValue({
      location: {
        [sessionBranchId]: {
          id: sessionBranchId,
          userFrontId: sessionBranchId,
        },
      },
    });
  },[sessionBranchId]);


  const handleSearchData = useCallback(
    debounce((searchValue: string) => {
      fetchData(
        searchValue,
        0,
        parseInt(pageOption),

        getLocationIds(checkedValue),
        getMembershipIds(checkedValue),
        getIsMobNoVerify(checkedValue),
        viewAnalyticData,
        contactFilteredIds,
        getCityIds(checkedValue),
        getStateIds(checkedValue),
        getCountryIds(checkedValue),
        getPinCodes(checkedValue),
        getCreatedByIds(checkedValue),
        getActiveStatus(checkedValue),
        getContactTypes(checkedValue)
      );
    }, 500),
    [
      selectedMembership,
      selectedBranch,
      selectedStatus,
      viewAnalyticData,
      pagination,
    ]
  );

  const handleChangePageOption = (e: { target: { value: any; }; }) => {
    const selectedValue = e.target.value;
    setPageOption(parseInt(selectedValue).toString());
    fetchData(
      searchValue,
      0,
      parseInt(selectedValue),
      getLocationIds(checkedValue),
      getMembershipIds(checkedValue),
      getIsMobNoVerify(checkedValue),
      viewAnalyticData,
      contactFilteredIds,
      getCityIds(checkedValue),
      getStateIds(checkedValue),
      getCountryIds(checkedValue),
      getPinCodes(checkedValue),
      getCreatedByIds(checkedValue),
      getActiveStatus(checkedValue),
      getContactTypes(checkedValue)
    );
  };

  const handlePageChange = (_: React.ChangeEvent<unknown>, page: number) => {
    fetchData(
      searchValue,
      (page - 1) * parseInt(pageOption),
      parseInt(pageOption),
      getLocationIds(checkedValue),
      getMembershipIds(checkedValue),
      getIsMobNoVerify(checkedValue),
      viewAnalyticData,
      contactFilteredIds,
      getCityIds(checkedValue),
      getStateIds(checkedValue),
      getCountryIds(checkedValue),
      getPinCodes(checkedValue),
      getCreatedByIds(checkedValue),
      getActiveStatus(checkedValue),
      getContactTypes(checkedValue)
    );
  };

  useEffect(() => {
    const fetchDynamicColumns = async () => {
      const res = await axiosFunction(
        `${v2ReactURL}/contact/dynamic/columns/get?tableName=${tabView}`,
        "GET"
      );
      if (res?.data?.status) {
        const toParseData = res?.data?.response?.jsonData?.dynamicColumns;
        setDynamicCol(toParseData);
        setDynamicColumn(tabWiseColumns);
        setChecked(res?.data?.response?.setDefault);
      } else {
        const initialFilteredColumns = tabWiseColumns.map((fil) => {
          return {
            key: fil.field,
            value: fil.defaultChecked ?? false,
            columnTitle: fil.headerName,
          };
        });

        setDynamicCol(initialFilteredColumns);
        setDynamicColumn(tabWiseColumns);
        setChecked(false);
      }
    };

    if (dynamicMenuAction) {
      fetchDynamicColumns();
    }
  }, [dynamicMenuAction]);


  const handleSearchColumn = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value.trimStart();

    setSearchColumn(value);

    const lowercasedSearchValue = value.toLowerCase();
    const filteredColumns = dynamicColumn.filter((column) =>
      column.headerName.toLowerCase().includes(lowercasedSearchValue)
    );

    setTableData(filteredColumns);
  };

  const handleSelectAllChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //  console.log("e",e.target.checked)
    e.stopPropagation();
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    const updatedRows = isChecked
      ? rows
        ?.filter((row) => row.branchId === sessionBranchId && (row.isDefault != 1 && row.isBranch != 1))
        ?.map((row) => row.contactId)
      : [];
      // console.log("setSelectAll",updatedRows)
    setSelectedRows(updatedRows);
    // console.log("updatedRows", updatedRows);/
  };

  const handleRowCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, rowIndex: number) => {
    // console.log("event", event.target.checked);
    const isChecked = event.target.checked;
    const updatedRows = [...selectedRows];
    if (isChecked) {
      updatedRows.push(rowIndex);
    } else {
      const index = updatedRows.indexOf(rowIndex);
      if (index !== -1) {
        updatedRows.splice(index, 1);
      }
    }

    setSelectedRows(updatedRows);
  };
  // useEffect(() => {
  //   const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
  //   if (isSafari) {
  //     toast.error("For the Best Experience Please use Google Chrome to access this system. Some features may not work properly in other browsers.", {
  //       autoClose: false,
  //       closeOnClick: true,
  //       draggable: true,
  //     });
  //   }
  // }, []);
  
  // const handleCardClick = async (data:tabData, index:number) => {
  //   setSearchValue("");
  //   const updatedCard = () => {
  //     const newSelectedCards : SelectedCard = { ...selectedCard };
  //     newSelectedCards[tabView] =
  //       index === newSelectedCards[tabView] ? [] : index;
  //     return newSelectedCards;
  //   };
  //   const updatedSelectedCardValue = updatedCard();
  //   setSelectedCard(updatedSelectedCardValue);
  //   const apiFieldObject = {
  //     newCustomerCount: 0,
  //     repeatCustomerCount: 0,
  //     notPurchasedLastSixMonths: 0,
  //     totalOutstandingCustomers: 0,
  //     totalPayableSupplier: 0,
  //     totalOrderValue: 0,
  //     totalTransporterOrderValue: 0,
  //   };
  //   if (data.apiField) {
  //     apiFieldObject[data.apiField as keyof typeof apiFieldObject] =
  //       index === updatedSelectedCardValue[tabView] ? 1 : 0;
  //   }
  //   dispatch(setAnalyticsData(apiFieldObject));
  //   setLoadingData(true);

  //   const {
  //     cityIds,
  //     status,
  //     isMobNoVerify,
  //     membershipIds,
  //     contactType: contactTypes,
  //     createdByIds,
  //     pincodes,
  //     contactIds,
  //   } = contactPayloadData;
  //   const payloadData = {
  //     searchValue: "",
  //     branchIds: selectedBranch,
  //     contactIds: contactIds,
  //     isMobNoVerify: isMobNoVerify,
  //     membershipIds: membershipIds,
  //     contactType: contactTypes,
  //     length: parseInt(pageOption),
  //     start: 0,
  //     draw: 1,
  //     createdByIds: createdByIds,
  //     cityIds: cityIds,
  //     pincodes: pincodes,
  //     status: status,
  //     ...apiFieldObject,
  //   };
  //   dispatch(setContactPayloadData(payloadData));
  //   const res = await axiosFunction(
  //     `${v2ReactURL}/contact/${contactType}/customdatatable`,
  //     "POST",
  //     payloadData
  //   );
  //   const validatedData = responseSchema.safeParse(res.data);
  //   if (res.status && validatedData.success) {
  //     const contactList = validatedData.data?.data?.map((col, index) => ({
  //       ...col,
  //       index: index + 1,
  //       checked: false,
  //     }));
  //     setLoadingData(false);
  //     setPagination(res.data.dataTableMetaDTO);
  //     setRows(contactList);
  //   } else {
  //     setLoadingData(false);
  //     console.error("API response validation failed:", validatedData.error);
  //   }
  // };
  const defaultChecker = (column: Column): boolean => {
    const dynamicColField = dynamicCol?.find((col) => col.key === column.field);
    return dynamicColField ? dynamicColField.value : column.defaultChecked || false;
  };

  const exportContactDataFunc = (data: RowData[]) => {

    let jsonArray: Record<string, any>[] = [];

    data?.map((row) => {
      let rowData: Record<string, any> = {};
      tabWiseColumns?.map((column: Column) => {
        if (!defaultChecker(column)) {
          return;
        }
        if (column.isExisted) {
          let val = column.renderCell
            ? column.isExisted({ row })
            : row[column.field as keyof RowData];
          rowData[column.headerName] = val;
        } else if (column.exportPdfName) {
          let val = column.renderCell
            ? column.exportPdfName({ row })
            : row[column.field as keyof RowData];
          rowData[column.headerName] = val;
        } else {
          let val =
            column.renderCell && column.headerName !== "Name"
              ? column.renderCell({ row })
              : row[column.field as keyof RowData];
          rowData[column.headerName] = val;
        }
      });

      delete rowData["Action"];
      jsonArray.push(rowData);
    });
    return jsonArray;
  };

  const exportData = () => {
    const rowData = exportContactDataFunc(rows);
    return rowData;
  };

  const exportAllData = (allRowData: RowData[]) => {
    const allRows = exportContactDataFunc(allRowData);
    return allRows;
  };

  const exportExcelData = () => {
    let jsonArray: Record<string, any>[] = [];

    let rowData: Record<string, any> = {};
    tabWiseColumns?.map((column) => {
      if (!defaultChecker(column)) {
        return;
      }
      rowData[column.headerName] = column.field;
      delete rowData["Action"];
      jsonArray.push(rowData);
    });
    return jsonArray[0];
  };

  // const tabsData =
  //   tabView === "customers"
  //     ? customerData(analyticsData)
  //     : tabView === "suppliers"
  //     ? supplierData(analyticsData)
  //     : transportData(analyticsData);

  const contactTabsView = [
    {
      label: "Customer",
      value: "customers",
      index: 0,
      show: contactRelatedData.permissions?.customers === 1,
    },
    {
      label: "Supplier/Vendor",
      value: "suppliers",
      index: 1,
      show: contactRelatedData.permissions?.suppliers === 1,
    },
    {
      label: "Transport",
      value: "transport",
      index: 2,
      show: contactRelatedData.permissions?.transport === 1,
    },
  ];
  // console.log("")

  // useEffect(() => {
  //   if (contactRelatedData?.permissions) {

  //     const priorityOrder = ['customers', 'suppliers', 'transport'];
  //     const result = priorityOrder.find((key) => contactRelatedData.permissions?.[key as keyof typeof contactRelatedData.permissions] === 1) || "";

  //     setTabView(result);
  //   }
  // }, [contactRelatedData]);
  if (tabView === '') {
    return (
      <ErrorPage
        error={{
          code: '403',
          message:
            "Whoops, access denied! Seems like you hit a dead end. Mysteries of the web, right?",
        }}
      />
    );
  }
  if (error) {
    return <ErrorPage error={error} />;
  }
  if (loadingContactData) {
    return <Loader />;
  }
  const columnsDataTable = tabWiseColumns?.map((col) => {
    const matchingItem = dynamicCol?.find((item1) => item1.key === col.field);
    if (matchingItem) {
      return { ...col, defaultChecked: matchingItem.value };
    }

    return col;
  });
  const toggleFilter = (column: Column) => {
    setSearchInputValue("");
    if (openFilter === column.field) {
      setOpenFilter(null);
    } else {
      setOpenFilter(column.field);
    }
  };
  const handleInputFocus = (field: string) => {
    setOpenFilter(field);
  };
  const handleApplyFilterBtn = (callFilterselection: boolean = true) => {
    handleApplyFilter(
      checkedValue,
      contactType,
      setContactFilteredIds,
      setFilteringData,
      fetchData,
      searchValue,
      pagination,
      pageOption,
      viewAnalyticData,
      setOpenFilter,         // Pass as prop
      sessionBranchId, 
      callFilterselection     // Pass as prop
    );
  };
  const handleClearFilter = () => {
    setContactFilteredIds([]);
    setFilteringData([]);
    setCheckedValue({
      location: {
        [sessionBranchId]: {
          id: sessionBranchId,
          userFrontId: sessionBranchId,
        },
      },
    });
    setOpenFilter(null);
    fetchData(
      searchValue,
      pagination.page * parseInt(pageOption),
      parseInt(pageOption),
      [sessionBranchId],
      [],
      "all",
      viewAnalyticData
    );
  };
  const resetLoyaltyPoints = async (resetAll: boolean) => {
    let mobileNumbers: string[] = [];

    if (!resetAll) {
      const rowData = rows.filter(row =>
          selectedRows.includes(row.contactId) && row.mobNo && row.loyaltyPoints !== 0);
      if (rowData.length === 0) {
        toastMessage("Customer's Mobile Number Is Not Provided or Loyalty Points Are Zero");
        return;
      }
      mobileNumbers = rowData.map(row => row.mobNo);
    }

    const result = await SwalFunction(
        "Are You Sure?",
        "You Won't Be Able To Revert This!",
        "Yes, Delete It!",
        {icon: "warning"}
    );

    if (result.isConfirmed) {
      resetPointsApi(resetAll, resetAll ? [] : mobileNumbers);
    }
  };
 

  const handleFetchData = async (): Promise<void> => {
    await fetchData(
      searchValue,
      pagination.page * parseInt(pageOption),
      parseInt(pageOption),
      [sessionBranchId],
      [],
      selectedStatus.value,
      viewAnalyticData
    );
  };


  return (
    <>
      <Helmet>
        <title>{navUrl}</title>
      </Helmet>
      <Wrapper navUrl={navUrl} customStyle={{ height: "750px" }}>
        <WrapperSubHeader className="mainBreadcrumb">
          <div className="mr-auto">
            <SubHeaderTitle subTitle={capitalizeFirstChar(tabView)} />
          </div>
        </WrapperSubHeader>
        <WrapperContent>
          <Row>
            <WrapperCard>
              <Tabination
                tabs={contactTabsView?.filter((data) => data.show)}
                handleTabChange={handleTabChange}
                tabView={tabView}
              />
              <CustomTabPanel>
                <Expanded
                 refreshAnalytics = {refreshAnalytics}
                  setRows={setRows}
                  tabView={tabView}
                  setPagination={setPagination}
                  pageOption={pageOption}
                  setSearchValue={setSearchValue}
                  setLoadingData={setLoadingData}
                  selectedBranch={selectedBranch}
                  setOpen={setOpen}
                  open={open}
                />
              </CustomTabPanel>
              <ContactContainer>
                <div className="custom-toolbar">
                  <div className="left-toolbar">
                    {/* <div className="pageBtn">
                      <PageOptions
                        pageOption={pageOption}
                        handleChangePageOption={handleChangePageOption}
                      />
                    </div> */}

                    <div className="columns-menu">
                      <CustomColumnMenuComponent
                        data={dynamicColumn}
                        setColumns={setDynamicColumn}
                        setOpenMenu={setOpenColumnMenu}
                        openMenu={openColumnMenu}
                        handleSearchColumn={handleSearchColumn}
                        searchColumn={searchColumn}
                        defaultColumns={tabWiseColumns}
                        dynamicCol={dynamicCol}
                        setDynamicCol={setDynamicCol}
                        checked={checked}
                        setChecked={setChecked}
                        tableData={tableData}
                        setSearchColumn={setSearchColumn}
                        checkedValue={checkedValue}
                        handleClearFilter={handleClearFilter}
                        open={open}
                      />
                      &ensp;
                      <ImportExport
                        exportData={exportData}
                        exportExcelData={exportExcelData}
                        exportAllData={exportAllData}
                        fetchData={handleFetchData}
                        selectedBranch={selectedBranch}
                        dynamicMenuAction={dynamicMenuAction}
                        setIsLoadingExcel={setIsLoadingExcel}
                        setProgress={setProgress}
                      />
                    </div>

                    {selectedRows.length > 0 && (
                      <SelectedRowsButtons
                        selectedRows={selectedRows}
                        resetLoyaltyPoints={resetLoyaltyPoints}
                        setSelectedRows={setSelectedRows}
                        dynamicMenuAction={dynamicMenuAction}
                        fetchData={() =>
                          fetchData(
                            searchValue,
                            0,
                            parseInt(pageOption),
                            selectedBranch,
                            selectedMembership,
                            selectedStatus.value,
                            viewAnalyticData,
                            contactFilteredIds,
                            getCityIds(checkedValue),
                            getStateIds(checkedValue),
                            getCountryIds(checkedValue),
                            getPinCodes(checkedValue),
                            getCreatedByIds(checkedValue),
                            getActiveStatus(checkedValue),
                            getContactTypes(checkedValue)
                          )
                        }
                        refreshAnalytics={refreshAnalytics}
                        setRefreshAnalytics={setRefreshAnalytics}
                      />
                    )}
                  </div>
                  <div className="search-toolbar">
                    {checkedValue &&
                      Object.keys(checkedValue).filter(
                        (key) =>
                          key !== "location" &&
                          checkedValue[key] &&
                          Object.keys(checkedValue[key]).length > 0
                      ).length > 0 && (
                        <CustomButton
                          onClick={handleClearFilter}
                          btnName={"Clear Filter"}
                          open={false}
                        />
                      )}

                    <div className="search-bar ml-3">
                      <input
                        type="text"
                        placeholder="Search List"
                        className="search-input"
                        style={{ height: "31px" }}
                        value={searchValue}
                        onChange={(e) => {
                          const value = e && e.target.value;
                          setSearchValue(value);
                          handleSearchData(value);
                        }}
                      />
                      <SearchIcon className="search-icon" />
                    </div>
                    {isShowCreateBtn ? (
                      <div className="create-btn-container">
                        <button
                          onClick={() => navigate("/reactcontact/new")}
                          className="create-btn"
                        >
                          <AddIcon className="add-mui" />
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                {selectedRows.length > 0 && (
                  <span className="selected-row-label">
                    {selectedRows.length} Selected
                  </span>
                )}
              </ContactContainer>
              {isLoadingExcel && (
                <CircularProgressCountUp
                  isLoadingExcel={isLoadingExcel}
                  onReset={() => setIsLoadingExcel(false)}
                  progress={progress}
                  setProgress={setProgress}
                />
              )}
              {isLoading ? (
                <CustomDataTable
                  rows={rows}
                  columns={columnsDataTable}
                  paginationInfo={pagination}
                  handlePageChange={handlePageChange}
                  pageOption={pageOption}
                  handleChangePageOption={handleChangePageOption}
                  loading={loadingData}
                  selectedRows={selectedRows}
                  isBranchFieldExist={false}
                  selectAll={selectAll}
                  handleSelectAllChange={handleSelectAllChange}
                  handleRowCheckboxChange={handleRowCheckboxChange}
                  defaultChecker={defaultChecker}
                  setCheckedValue={setCheckedValue}
                  checkedValue={checkedValue}
                  handleApplyFilterBtn={handleApplyFilterBtn}
                  toggleFilter={toggleFilter}
                  openFilter={openFilter}
                  setOpenFilter={setOpenFilter}
                  handleInputFocus={handleInputFocus}
                  branchLocationList={branchLocationList}
                  membershipList={membershipList}
                  // handleSelectAllData={handleSelectAllData}
                  filterData={filterData}
                  setFilterData={setFilterData}
                  handleSearch={handleSearch}
                  contactFilteredIds={contactFilteredIds}
                  setContactFilteredIds={setContactFilteredIds}
                  filteringData={filteringData}
                  setSearchInputValue={setSearchInputValue}
                  searchInputValue={searchInputValue}
                />
              ) : (
                <span
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "white",
                    border: "none",
                    height: "50vh",
                    width: "100%",
                  }}
                >
                  <CircularProgress />
                </span>
              )}
            </WrapperCard>
          </Row>
        </WrapperContent>
      </Wrapper>
      <EditPointsDialog
        editPointsDialogData={editPointsDialogData}
        setEditPointsDialogData={setEditPointsDialogData}
        onSuccess={() =>
          fetchData(
            searchValue,
            pagination.page * parseInt(pageOption),
            parseInt(pageOption),
            [sessionBranchId],
            [],
            selectedStatus.value,
            viewAnalyticData
          )
        }
      />
    </>
  );



};

export default MainParentComponent;
